export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_6.d0763c62.jpg";